import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import './App.css';
import { getActiveUser } from './api/api.js';
import Nav from './Nav.js';
import Exercise from './exercise/Exercise.js';
import Theory from './theory/Theory.js';
import Account from './account/Account.js';
import Footer from './Footer.js';
import './ui.js';
import 'bulma/css/bulma.min.css';

const App = () => {
    const [user, setUser] = useState(null);

    useEffect(() => {
        (async () => {
            const result = await getActiveUser();
            if (result !== undefined) {
                setUser(result);
            }
        })();
    }, []);

    return (
        <Router>
            <Nav {...{ user, setUser }} />
            <Switch>
                <Redirect exact from="/" to="/exercise" />
                <Route path="/exercise" render={(props) => <Exercise {...props} {...{user}} />} />
                <Route path="/theory" component={Theory} />
                <Route path="/account" render={(props) => <Account {...props} {...{user, setUser}} />} />
            </Switch>
            <Footer />
        </Router>
    )
}

export default App;
